import Vue from "vue";

function clearDni(dni: string) {
  return dni.replace(/[^0-9kK]+/g, "").toLowerCase();
}

function formarDni(dni: string) {
  if (dni.length > 1) {
    dni = dni.slice(0, -1) + "-" + dni.slice(-1);
    if (dni.length > 5) {
      if (dni.length > 8) {
        return dni.slice(0, -8) + "." + dni.slice(-8, -5) + "." + dni.slice(-5);
      }
      return dni.slice(0, -5) + "." + dni.slice(-5);
    }
  }
  return dni;
}

export function getDV(dni: string) {
  var numberDni = clearDni(dni).slice(0, -1);
  if (numberDni.length > 6) {
    var auxArray = [3, 2, 7, 6, 5, 4, 3, 2];
    var sum = 0;

    for (var i = numberDni.length - 1; i >= 0; i--) {
      sum += parseInt(numberDni[i]) * auxArray[i];
    }
    switch (11 - (sum % 11)) {
      case 11:
        return "0";
      case 10:
        return "k";
      default:
        return (11 - (sum % 11)).toString();
    }
  }
  return null;
}

export function validateDni(dni: string) {
  var numberDni = clearDni(dni).slice(0, -1);
  if (numberDni.length > 6) {
    var auxArray = [3, 2, 7, 6, 5, 4, 3, 2];
    var sum = 0;

    for (var i = numberDni.length - 1; i >= 0; i--) {
      sum += parseInt(numberDni[i]) * auxArray[i];
    }
    switch (11 - (sum % 11)) {
      case 11:
        return dni.slice(-1) == "0";
      case 10:
        return dni.slice(-1) == "k" || dni.slice(-1) == "K";
      default:
        return dni.slice(-1) == (11 - (sum % 11)).toString();
    }
  }
  return false;
}

export function dniFilter(value: string, calculateDV: boolean = false) {
  let _value = value;
  if (calculateDV) _value = value + getDV(value);
  return formarDni(clearDni(_value));
}

export function dniToNumber(dni: string | number | undefined): number | string {
  if (typeof dni == "string" && validateDni(dni)) {
    return Number(
      dni
        .toLowerCase()
        .replace(/[.-]/g, "")
        .slice(0, -1)
    );
  }
  return dni || "";
}
